import { Button, useConfig } from "@4uhub/lib4uhub";
import { Box } from "@mui/material";
import { memo, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import useDownload from "../../../../../hooks/useDownload";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";

const DOWNLOAD_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/ListImportBatch/template";

const translationPath = "page.4uDlist.listFiles.";

export const DownloadModelButton = memo(() => {
  const { t } = useTranslation();

  const {
    configuration: {
      language: { id: languageId },
    },
  } = useConfig();

  const { downloadFileParams, loading } = useDownload();

  const downloadParams = useMemo(() => {
    return {
      languageId,
    };
  }, [languageId]);

  const downloadModelHandler = useCallback(() => {
    downloadFileParams(
      DOWNLOAD_ROUTE,
      downloadParams,
      t(translationPath + "model_file_name"),
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    );
  }, [t, downloadFileParams, downloadParams]);

  return (
    <Box sx={{ whiteSpace: "nowrap" }}>
      <Button
        variant="contained"
        disableElevation
        startIcon={<DownloadRoundedIcon />}
        onClick={downloadModelHandler}
        loading={loading}
      >
        {t(translationPath + "download") || "Download Model"}
      </Button>
    </Box>
  );
});
